import { store } from 'src/common/redux/configure-store';
import { PaymentMessage } from './dtos/eps-data';

export const getTouchpointData = (): PaymentMessage => {
  return {
    nmpMessage: {
      touchPointId: store.getState().touchPoint.touchPointConfiguration.touchPointId,
      storeId: store.getState().touchPoint.touchPointConfiguration.storeId,
      workerId: store.getState().user.workerId,
    },
  };
};
